module.exports = __webpack_public_path__ + "img/logo5.9c9b53bd.png";